import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute, Params, Data } from "@angular/router";
import { FormConfigModel } from '@shared/_models/Layout/FormConfig';
import { StatusCode } from '@shared/_enums/Common';
import { CommonService } from '@services/app.common.service';
import { SystemUser, ClienDivisionsSecurity } from '@shared/_models/settings/userSettingModels';
import { ClienDivisionsSecurityDTO } from '@shared/_models/settings/settingsModels';
import { RoleAccessService } from '@services/role.access.service';
import { PwnedPasswordService } from '../../_shared/_services/pwned-password.service';

@Component({
    selector: 'app-update-userpassword.component',
    templateUrl: './updateUserPassword.component.html',
    styleUrls: ['./updateUserPassword.component.css'],
    standalone: false
})


export class updateUserPasswordComponent implements OnInit {
  public systemuserid: number = 0;
  public gsystemuserid: string = '';
  public securityCode: string = '';
  public StatusCode = StatusCode;
  public modalConfig = {} as FormConfigModel;
  public user = {} as SystemUser;
  public clienDivisionsSecurity = {} as ClienDivisionsSecurity;
  public submittedApplicationForm = '';
  //public tokenResponse: any;
  public isShow = false;
  public paswordComplexity = {} as ClienDivisionsSecurityDTO;
  public notValidPattern = '';
  public notEquivalent = '';
  public password: string = '';
  public confirPassword: string = '';
  public PasswordInstruntion: string = '';
  isPasswordBreached: boolean = false;
  token: string = '';
  shouldCheckBreachedPassword: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public common: CommonService,
    private renderer: Renderer2,
    public roleService: RoleAccessService,
    public pwnedPasswordService: PwnedPasswordService
  ) {

    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');

  }

  ngOnInit() {


    this.route.queryParams.subscribe((params: Params) => {

      this.systemuserid = params['systemUserId'];
      this.gsystemuserid = params['gSystemUserId'];
    });
    this.securityCode = this.common.GetFromSessionStorage('forgotPasswordSecurityCode') || '';

    this.route.data.subscribe((data: Data) => {
      var tokenResponse = data['tokenResponse'];
      this.token = `Bearer ${tokenResponse.resultData}`;
    });

    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    this.PopulateData();
    this.LoadLoginConfiguration();
  }
  public PopulateData() {
    this.common.GetData(this.common.ApiUrls.SystemUser.GetPasswordComplexityDetail, true).then(data => {
      this.paswordComplexity = data.resultData.passwordComplexity;
      this.strengthChanged();
    });
  }

  async ChangePassword() {
    this.user.id = this.systemuserid;
    this.user.guid = this.gsystemuserid;
    this.user.securityCode = this.securityCode;
    this.user.password = this.user.password;
    this.user.confirmPassword = this.user.confirmPassword;
    this.user.isOnlyPasswordUpdate = true;
    this.isPasswordBreached = false;
    if (this.common.isNullOrWhiteSpace(this.common.message)) {
      this.common.message = this.common.GetTranslation('Common.passwordContain' + this.paswordComplexity.minLength + 'Common.characters' + this.paswordComplexity.numberLength + 'Common.digits' + this.paswordComplexity.upperLength + 'Common.uppercase' + this.paswordComplexity.specialLength + 'Common.specialcharacter' + this.paswordComplexity.specialChars);
      // this.common.message = `Your password must contain at least ${this.paswordComplexity.minLength} characters, of which a minimum of ${this.paswordComplexity.numberLength} should be digits (0-9), ${this.paswordComplexity.upperLength} upper case character and ${this.paswordComplexity.specialLength} special character. Allowed special character: ${this.paswordComplexity.specialChars}`
    }
    this.isShow = true;
    this.submittedApplicationForm = 'true';
    if (this.user.password) {
      const matchPassword = this.user.password.match('^(?=.*[A-Z])(?=.*[0-9])(?=.*[' + this.paswordComplexity.specialChars + '])(?=.{' + this.paswordComplexity.minLength + ',})');
      const spaces = this.common.CountRegExp(this.user.password, /\s/g);
      let inValidChars = '';
      const allowableSpecilaChars = new RegExp('[' + this.paswordComplexity.specialChars + ']', 'g');
      inValidChars = this.user.password.replace(/[a-z]/gi, '') + inValidChars.replace(/\d/g, '');
      inValidChars = inValidChars.replace(/\d/g, '');
      inValidChars = inValidChars.replace(allowableSpecilaChars, '');
      if (matchPassword == null || spaces > 0 || inValidChars !== '') {
        this.notValidPattern = 'true';
        return;
      } else {
        this.notValidPattern = '';
      }
    } else {
      this.notValidPattern = 'true';
      return;
    }
    if (this.notEquivalent == 'true') {
      return;
    } else {
      this.notEquivalent == '';
    }

    this.isPasswordBreached = await this.pwnedPasswordService.isPasswordBreached(this.user.password, this.shouldCheckBreachedPassword);
    if (this.isPasswordBreached) {
      return;
    }
    else {
      this.common.PostData(this.common.ApiUrls.SystemSettings.UpdateSystemUserPassword, this.user, true).then(data => {
        if (data.status == StatusCode.OK) {
          this.common.Notification.success(this.common.GetTranslation('Login.PasswordChanged'));
            this.common.NavigateToRoute('Login');
            this.common.RemoveSessionStorage('forgotPasswordSecurityCode');
        } else {
          this.common.Notification.error(this.common.GetTranslation('Messages.SomeThingWentWrong'));
        }
      });
      this.password = '';
      this.confirPassword = '';
      this.common.message = '';
    }

  }
  public checkIfMatchingPasswords(e:any) {

    const passwordInput = this.user.password,
      passwordConfirmationInput = this.user.confirmPassword;
    // if (passwordInput != "") {
      if (passwordInput !== passwordConfirmationInput) {
        this.notEquivalent = 'true';
        this.submittedApplicationForm = 'true';
        this.notValidPattern = 'true';
        return;
      } else {
        this.notEquivalent = '';
        this.notValidPattern = '';
        this.submittedApplicationForm = '';

      }
    // }
    // else {
    //  this.notEquivalent = "";
    //  this.notValidPattern = "";
    //  this.submittedApplicationForm = "";

    // }
  }

  public strengthChanged() {
    this.isShow = false;
    this.common.GetPasswordStrengthInfo(this.user.password, this.paswordComplexity);
  }
  private LoadLoginConfiguration(): void {
    this.common.GetData(this.common.ApiUrls.AnonymousUser.LoadLoginConfiguration, false, this.token).then(data => {
      if (data.status == StatusCode.OK) {
        this.shouldCheckBreachedPassword = data?.resultData?.configEnableBreachedPasswordCheck;
      }
    });
  }

  }

